<div class="feedback feedback--{{ variant }}">
  <h2 mat-dialog-title class="feedback__title">{{ data.title }}</h2>

  <mat-icon class="feedback__icon" aria-hidden="true">{{ icon }}</mat-icon>

  <p *ngIf="data.message" class="feedback__message">{{ data.message }}</p>

  <div class="feedback__actions">
    <button type="button" mat-dialog-close class="feedback__close">
      {{ data.closeLabel ?? lextranslate.i18n["42551837-6900-4788-bfbb-d086da62c931"] }}
    </button>
  </div>
</div>
